import React from "react";
import { Typography } from "@mui/material";
import { CustomFieldLabel } from "../../../components/fields/CustomFieldLabel/CustomFieldLabel";

interface ProjectQuestionToggleProps {
  label: string;
  value: boolean;
  onChange: (val: boolean) => void;
  width?: string;
}

export const ProjectQuestionToggle = ({
  label,
  value,
  onChange,
  width = "16%",
}: ProjectQuestionToggleProps) => {
  return (
    <div className="flex flex-col items-start gap-2">
      <CustomFieldLabel>{label}</CustomFieldLabel>
      <div
        className="flex rounded-xl overflow-hidden border border-border-token max-sm:!min-w-[150px]"
        style={{ width }}
      >
        <div
          className={`w-1/2 flex justify-center items-center py-2 cursor-pointer ${
            value ? "bg-tint" : "bg-surface"
          }`}
          onClick={() => onChange(true)}
        >
          <Typography
            sx={{
              color: value ? "var(--accent-text)" : "var(--muted)",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 900,
              lineHeight: "normal",
              textAlign: "center",
            }}
          >
            Yes
          </Typography>
        </div>
        <div
          className={`w-1/2 flex justify-center items-center py-2 cursor-pointer border-l border-border-token ${
            !value ? "bg-tint" : "bg-surface"
          }`}
          onClick={() => onChange(false)}
        >
          <Typography
            sx={{
              color: !value ? "var(--accent-text)" : "var(--muted)",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 900,
              lineHeight: "normal",
              textAlign: "center",
            }}
          >
            No
          </Typography>
        </div>
      </div>
    </div>
  );
};
